module.exports = __webpack_public_path__ + "static/img/top_bg.473a3f23.png";